(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgm-inspiration-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tgm-story-gallery')) {
    customElements.define('tgm-story-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        this.slides = Array.from(this.querySelectorAll('.tgm-story__slide'));
        this.controls = this.querySelector('[data-gallery-controls]');
        if (!this.track || !this.controls || this.slides.length < 2) return;
        this.previous = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');
        this.status = this.querySelector('[data-gallery-status]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.controls.hidden = false;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        const left = this.track.getBoundingClientRect().left;
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const current = Math.abs(slide.getBoundingClientRect().left - left);
          if (current < distance) { distance = current; nearest = index; }
        });
        this.index = nearest;
        this.previous.disabled = nearest === 0;
        this.next.disabled = nearest === this.slides.length - 1;
        const label = `${nearest + 1} / ${this.slides.length}`;
        if (this.status.textContent !== label) this.status.textContent = label;
      }
      move(direction) {
        const index = Math.max(0, Math.min(this.slides.length - 1, this.index + direction));
        const delta = this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
